import axios from "./_axios";
import { API } from "./apiEndPoints";

const followsUrl = (account_id, suffix = "") =>
  `${API.ACCOUNT_FOLLOWS}${account_id}/follows/${suffix}`;

/**
 * Lists the signed-in user's follows (ER-12317). Each row also carries the
 * user's Chatter `cadence` while idea-MDP-583 is on.
 * @param {number|string} account_id
 * @param {{ limit?: number, offset?: number }} [options]
 */
export const getMyFollows = (account_id, { limit = 100, offset = 0 } = {}) =>
  axios()({
    method: "get",
    url: followsUrl(account_id),
    params: { access: "me", limit, offset },
  });

/**
 * Follows an object on behalf of an Access. Idempotent: following again returns
 * the existing row.
 * @param {number|string} account_id
 * @param {{ access: number|string, object_type: string, object_id: number|string }} payload
 */
export const followObject = (account_id, payload) =>
  axios()({ method: "post", url: followsUrl(account_id), data: payload });

/** Removes one follow row. */
export const unfollowObject = (account_id, follow_id) =>
  axios()({ method: "delete", url: followsUrl(account_id, `${follow_id}/`) });

/**
 * Saves the signed-in user's Chatter notification cadence.
 * @param {"daily"|"immediately"} cadence
 */
export const setFollowCadence = (account_id, cadence) =>
  axios()({ method: "put", url: followsUrl(account_id, "cadence/"), data: { cadence } });
